import axios from 'axios';

const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

// Cola de revisión de solicitudes de oposición ARCO+ (Ley 21.719) — consume la API
// admin ya construida en pawer-backend (049-arco-opposition-request). Este servicio
// no agrega lógica de negocio, solo transporte (Constitution I).
export default class OppositionRequestsService {
  static async list(status) {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try {
      const response = await axios.get(`${ADMIN_URL}/opposition-requests`, {
        params: status ? { status } : {},
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      return { status: 'error' };
    }
  }

  static async review(id, decision, decisionReason) {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try {
      const body = { decision };
      if (decisionReason) body.decisionReason = decisionReason;
      const response = await axios.patch(
        `${ADMIN_URL}/opposition-requests/${id}/review`,
        body,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      const message = error?.response?.data?.error?.message || 'No se pudo registrar la decisión.';
      return { status: 'error', message };
    }
  }

  static async blockReview(id, blockDecision, blockDecisionReason) {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try {
      const body = { blockDecision };
      if (blockDecisionReason) body.blockDecisionReason = blockDecisionReason;
      const response = await axios.patch(
        `${ADMIN_URL}/opposition-requests/${id}/block-review`,
        body,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      const message = error?.response?.data?.error?.message || 'No se pudo registrar la decisión de bloqueo.';
      return { status: 'error', message };
    }
  }
}
